import { defineComponent as _defineComponent } from 'vue'
import { defineAsyncComponent, computed, getCurrentInstance } from 'vue';
import {
  format,
  parseISO,
  DATE_TIME_FORMATS,
  addMinutes,
  formatWithLocale,
} from '@white-label-helper/date-utilities';
import { FEATURE_FLAGS } from '@white-label-configuration/constants';


import { getAppVariable } from '@white-label-helper/get-app-variable';

interface EntryExitInfoProps {
  label?: string,
  dateTimeString?: string,
  bigTitle?: boolean,
  inLine?: boolean,
  period?: number,
  endPeriodTime?: string,
  visitingDuration?: string,
  customClasses?: Record<string, boolean>,
  isTravelExtras?: boolean,
  dateTimeFormat?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'entry-exit-info',
  props: {
    label: { default: 'Entry' },
    dateTimeString: { default: '' },
    bigTitle: { type: Boolean },
    inLine: { type: Boolean, default: false },
    period: { default: 0 },
    endPeriodTime: { default: '' },
    visitingDuration: { default: '' },
    customClasses: { default: () => ({}) },
    isTravelExtras: { type: Boolean, default: false },
    dateTimeFormat: { default: DATE_TIME_FORMATS.month_day_year }
  },
  setup(__props: any) {

const props = __props as { label: string, dateTimeString: string, bigTitle?: boolean, inLine: boolean, period: number, endPeriodTime: string, visitingDuration: string, customClasses: Record<string, boolean>, isTravelExtras: boolean, dateTimeFormat: string };

const { proxy } = getCurrentInstance() as any;
const i18n = proxy.$i18n;
const launchDarkly = proxy.$launchDarkly;



const IconCalendar = defineAsyncComponent(() => import('@white-label-icon/icon-calendar'));
const IconWatch = defineAsyncComponent(() => import('@white-label-icon/icon-watch'))

const date = computed(() => {
  if (!props.dateTimeString) return '';
  return formatWithLocale(
    parseISO(props.dateTimeString),
    props.dateTimeFormat,
    i18n.locale
  )
})

const time = computed(() => {
  if (!props.dateTimeString) return '';

  const countryCode = getAppVariable('poi.country.code');
  const isEnglishFormat = countryCode === 'US' || countryCode === 'GB';

  let timeFormat = DATE_TIME_FORMATS.time_24hr;

  if (isEnglishFormat) {
    timeFormat = props.isTravelExtras
      ? DATE_TIME_FORMATS.time_lower_case
      : DATE_TIME_FORMATS.time;
  }

  return format(parseISO(props.dateTimeString), timeFormat);
});

const endTime = computed(() => {
  return props.endPeriodTime
    ? format(parseISO(props.endPeriodTime), DATE_TIME_FORMATS.time)
          : props.period && props.dateTimeString
          ? format(
              addMinutes(parseISO(props.dateTimeString), props.period),
              DATE_TIME_FORMATS.time
            )
          : '';
});

const enableAetherImprovements = computed(() => {
  return launchDarkly.variation(FEATURE_FLAGS.PREM_636_AETHER_PHASE_1_IMPROVEMENTS);
});


return { __sfc: true,proxy, i18n, launchDarkly, props, IconCalendar, IconWatch, date, time, endTime, enableAetherImprovements }
}

})